<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <div class="p-7 space-y-5">
    <form
      *ngIf="form"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
    >
      <div class="flex items-start justify-between mb-4">
        <div class="flex items-start gap-2.5">
          <div
            class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
          >
            <igntr-icon name="home"></igntr-icon>
          </div>
          <div>
            <div class="text-[14px] font-semibold !text-slate-900">
              {{ "home" | transloco }}
            </div>
            <div class="text-[12px] !text-slate-500 mt-0.5">
              {{ "informationAboutTenant" | transloco }}
            </div>
          </div>
        </div>
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium disabled:opacity-60 disabled:cursor-not-allowed"
          type="submit"
          [disabled]="isSaving"
        >
          {{ "save" | transloco }}
        </button>
      </div>
      <div class="rounded-xl border !border-slate-200/70 bg-white">
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">
              {{ "tenantName" | transloco }}
            </span>
          </div>
          <div [appValidateState]="form.get('name')">
            <input
              id="tenant-name-field"
              formControlName="name"
              type="text"
              class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
              [class.input-invalid]="
                form.get('name')?.invalid && form.get('name')?.touched
              "
              placeholder="{{ 'tenantName' | transloco }}"
              i18n-placeholder="Tenant name placeholder @@tenantName"
              [style]="
                form.get('name')?.invalid && form.get('name')?.touched
                  ? 'border-color: #ef4444 !important; box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2), 0 0 0 4px rgba(239, 68, 68, 0.08) !important;'
                  : ''
              "
            />
          </div>
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              "cvr" | transloco
            }}</span>
          </div>
          <input
            formControlName="cvr"
            type="text"
            class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="{{ 'cvrNumber' | transloco }}"
            i18n-placeholder="Tenant CVR number placeholder @@cvr"
          />
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              "address" | transloco
            }}</span>
          </div>
          <input
            formControlName="address"
            type="text"
            class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="{{ 'tenantAddress' | transloco }}"
            i18n-placeholder="Tenant address placeholder @@address"
          />
        </div>

        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              "mainMail" | transloco
            }}</span>
          </div>
          <input
            formControlName="mainMail"
            type="text"
            class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="{{ 'mainMail' | transloco }}"
            i18n-placeholder="Main mail placeholder @@mainMail"
          />
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              "phone" | transloco
            }}</span>
          </div>
          <input
            formControlName="phoneNumber"
            type="text"
            class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="{{ 'phone' | transloco }}"
            i18n-placeholder="Tenant phone number placeholder @@phoneNumber"
          />
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              "URL" | transloco
            }}</span>
          </div>
          <input
            formControlName="preferedUrl"
            type="text"
            class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="URL"
          />
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">
              {{ "tenantRemarks" | transloco }}
            </span>
          </div>
          <textarea
            rows="3"
            style="height: 100%"
            formControlName="remarks"
            type="text"
            class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
            placeholder="{{ 'tenantRemarks' | transloco }}"
            i18n-placeholder="Tenant remarks placeholder @@remarks"
          ></textarea>
        </div>
        <div
          class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0 flex justify-around flex-wrap gap-2"
        >
          <div class="min-w-[200px]">
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "desktopLogo" | transloco }}
            </div>
            <app-media-library-drop-zone
              [mediaLibraryFiles]="[logoMediaLibraryFile]"
              [allowImagesSelection]="true"
              [showOnlyPrivateFiles]="true"
              (onFileSelected)="onDesktopLogoMediaLibraryFileSelected($event)"
              (onFileRemoved)="onLogoMediaLibraryFileRemoved(true)"
            ></app-media-library-drop-zone>
          </div>

          <div class="min-w-[200px]">
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "mobileLogo" | transloco }}
            </div>
            <app-media-library-drop-zone
              [mediaLibraryFiles]="[mobileLogoMediaLibraryFile]"
              [allowImagesSelection]="true"
              [showOnlyPrivateFiles]="true"
              (onFileSelected)="onMobileLogoMediaLibraryFileSelected($event)"
              (onFileRemoved)="onLogoMediaLibraryFileRemoved(false)"
            ></app-media-library-drop-zone>
          </div>
        </div>

        <div
          class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0 grid grid-col-1 md:grid-cols-3"
        >
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="allowUnauthorizedAccess"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "allowUnauth" | transloco }}
              </div>
            </div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="chatGPTForTenant"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "useChatGPT" | transloco }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="chatGPTForCoach"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "useChatGPTForCoach" | transloco }}
              </div>
            </div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="publicDataRoom"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "publicDataRoom" | transloco }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="multipleDataRoom"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "Multiple DataRoom" | transloco }}
              </div>
            </div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="hideMediaLibraryFolder"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "hideMediaFolder" | transloco }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="hideUsersFolder"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "hideUsersFolder" | transloco }}
              </div>
            </div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                class="w-[13px]"
                formControlName="hideTemplateFolder"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "hideTemplateFolder" | transloco }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
              *ngIf="authRepo.isSuperAdmin$ | async"
            >
              <input
                formControlName="isPartnerTenant"
                class="w-[13px]"
                type="checkbox"
                (change)="changeIsPartner($event)"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "partnerTenant" | transloco }}
              </div>
            </div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                formControlName="speechToText"
                class="w-[13px]"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "useSpeechToText" | transloco }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                formControlName="liveAvatar"
                class="w-[13px]"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "useLiveAvatar" | transloco }}
              </div>
            </div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
            >
              <input
                formControlName="isDisabled"
                class="w-[13px]"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "disableTenant" | transloco }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
              *ngIf="calendarHere$"
            >
              <input
                formControlName="showCalendarAsList"
                class="w-[13px]"
                type="checkbox"
              />
              <div class="text-[14px] !text-slate-700">
                {{ "showCalendarAsList" | transloco }}
              </div>
            </div>
          </div>
        </div>

        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div
            class="flex items-center px-2.5 py-1.5 rounded-md w-100 grid grid-col-1 md:grid-cols-3 gap-3"
          >
            <div>
              <div *ngIf="isUsersLoading">
                <div class="text-[14px] font-medium !text-slate-700 mb-1">
                  {{ "features" | transloco }}:
                </div>
                <div
                  class="h-[30px] rounded-lg bg-slate-200 animate-pulse"
                ></div>
              </div>
              <app-datalist-select
                *ngIf="!isUsersLoading && !isIgniteTenant"
                class="app-datalist-select-double-height"
                [options]="featureOptions"
                [multiple]="true"
                [activeValue]="form.value.featureIds"
                (activeValueChange)="updateValue('featureIds', $event)"
                label="{{ 'features' | transloco }}:"
              ></app-datalist-select>

              <div *ngIf="!isUsersLoading && isIgniteTenant">
                <div class="text-[14px] font-medium !text-slate-700 mb-1">
                  {{ "features" | transloco }}:
                </div>
                <div class="flex flex-wrap gap-1.5">
                  <span
                    *ngFor="let option of igniteFeatureOptions"
                    class="inline-flex items-center px-2 py-0.5 rounded-md bg-slate-100 !text-slate-700 text-[14px] font-medium"
                  >
                    {{ option.label }}
                  </span>
                </div>
                <div class="text-[12px] !text-slate-500 mt-1">
                  {{ "igniteFeaturesLocked" | transloco }}
                </div>
              </div>
            </div>

            <div>
              <div *ngIf="isUsersLoading">
                <div class="text-[14px] font-medium !text-slate-700 mb-1">
                  {{ "mobile" | transloco }} {{ "menu" | transloco }}:
                </div>
                <div
                  class="h-[30px] rounded-lg bg-slate-200 animate-pulse"
                ></div>
              </div>
              <app-datalist-select
                *ngIf="!isUsersLoading"
                class="app-datalist-select-double-height"
                [options]="mobileFeatureOptions"
                [multiple]="true"
                [activeValue]="form.value.mobileFeatureIds"
                (activeValueChange)="updateValue('mobileFeatureIds', $event)"
                label="{{ 'mobile' | transloco }} {{ 'menu' | transloco }}:"
              ></app-datalist-select>
            </div>
            <div id="tenant-users-field">
              <div *ngIf="isUsersLoading">
                <div class="text-[14px] font-medium !text-slate-700 mb-1">
                  {{ "users" | transloco }}:
                </div>
                <div
                  class="h-[30px] rounded-lg bg-slate-200 animate-pulse"
                ></div>
              </div>
              <app-datalist-select
                *ngIf="!isUsersLoading"
                [forUsers]="true"
                class="app-datalist-select-double-height"
                [options]="userOptions"
                [multiple]="true"
                label="{{ 'users' | transloco }}:"
                [(activeValue)]="selectedUserIds"
                (activeValueChange)="updateValue('userIds', $event)"
              />
              <div
                *ngIf="
                  (form.get('userIds')?.touched &&
                    form.get('userIds')?.errors?.['required']) ||
                  form.get('userIds')?.errors?.['noUsers']
                "
                class="text-danger mt-1 text-[14px]"
              >
                {{ "selectAtLeastOneUser" | transloco }}
              </div>
            </div>
          </div>
        </div>
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "primaryColor" | transloco }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-colorpicker formControlName="primaryColor"></p-colorpicker>
              <input
                type="text"
                formControlName="primaryColor"
                class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
                [class.input-invalid]="
                  form.get('primaryColor')?.invalid &&
                  form.get('primaryColor')?.touched
                "
                [value]="form?.value.primaryColor"
              />
            </div>
          </div>

          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "secondaryColor" | transloco }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-colorpicker formControlName="secondaryColor"></p-colorpicker>
              <input
                formControlName="secondaryColor"
                type="text"
                class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
                [class.input-invalid]="
                  form.get('secondaryColor')?.invalid &&
                  form.get('secondaryColor')?.touched
                "
                [value]="form?.value.secondaryColor"
              />
            </div>
          </div>

          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "backgroundColor" | transloco }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-colorpicker formControlName="backgroundColor"></p-colorpicker>
              <input
                type="text"
                formControlName="backgroundColor"
                class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
                [class.input-invalid]="
                  form.get('backgroundColor')?.invalid &&
                  form.get('backgroundColor')?.touched
                "
                [value]="form?.value.backgroundColor"
              />
            </div>
          </div>
          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "menuBackgroundColor" | transloco }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-colorpicker
                formControlName="menuBackgroundColor"
              ></p-colorpicker>
              <input
                type="text"
                class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
                formControlName="menuBackgroundColor"
                [class.input-invalid]="
                  form.get('menuBackgroundColor')?.invalid &&
                  form.get('menuBackgroundColor')?.touched
                "
                [value]="form?.value.menuBackgroundColor"
              />
            </div>
          </div>
          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "appThemeColor" | transloco }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-colorpicker formControlName="appThemeColor"></p-colorpicker>
              <input
                type="text"
                class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
                formControlName="appThemeColor"
                [class.input-invalid]="
                  form.get('appThemeColor')?.invalid &&
                  form.get('appThemeColor')?.touched
                "
                [value]="form?.value.appThemeColor"
              />
            </div>
          </div>
          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "emailColor" | transloco }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-colorpicker formControlName="emailColor"></p-colorpicker>
              <input
                type="text"
                class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
                formControlName="emailColor"
                [class.input-invalid]="
                  form.get('emailColor')?.invalid &&
                  form.get('emailColor')?.touched
                "
                [value]="form?.value.emailColor"
              />
            </div>
          </div>
          <!-- <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0 mb-3"> -->
          <div>
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "font" | transloco }}
            </div>
            <!-- <p-dropdown
        placeholder="Default"
        class="w-100"
        [options]="fontOptions"
        formControlName="fontFamily"
      ></p-dropdown> -->

            <app-datalist-select
              placeholder="Default"
              [options]="fontOptions"
              [multiple]="false"
              [activeValue]="form.get('fontFamily')?.value"
              (activeValueChange)="updateValue('fontFamily', $event)"
            ></app-datalist-select>
          </div>

          <div *ngIf="isPartner && (authRepo.isSuperAdmin$ | async)" class="">
            <div class="">
              <div
                class=""
                [class.is-invalid]="
                  form.get('maxUsersCanCreate')?.hasError('min') ||
                  form.get('maxUsersCanCreate')?.hasError('pattern')
                "
              >
                <div class="text-[14px] font-medium !text-slate-700">
                  {{ "maxUsers" | transloco }}
                </div>
                <input
                  formControlName="maxUsersCanCreate"
                  class="inpt"
                  type="number"
                  min="0"
                  [class.input-invalid]="
                    form.get('maxUsersCanCreate')?.invalid &&
                    form.get('maxUsersCanCreate')?.touched
                  "
                />
              </div>
            </div>
            <div class="">
              <div
                class=""
                [class.is-invalid]="
                  form.get('maxTenantsCanCreate')?.hasError('min') ||
                  form.get('maxTenantsCanCreate')?.hasError('pattern')
                "
              >
                <div class="text-[14px] font-medium !text-slate-700">
                  {{ "maxTenants" | transloco }}
                </div>
                <input
                  formControlName="maxTenantsCanCreate"
                  class="inpt"
                  type="number"
                  min="0"
                  [class.input-invalid]="
                    form.get('maxTenantsCanCreate')?.invalid &&
                    form.get('maxTenantsCanCreate')?.touched
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0 mt-3">
      <div class="form-group form-floating pb-3 d-grid">
        <button
          type="submit"
          class="btn btn-orange shadow-sm"
          i18n="Save button @@save"
        >
          {{ "save" | transloco }}
        </button>
      </div>
    </div> -->
      </div>
    </form>
  </div>
</div>
